module.exports = __webpack_public_path__ + "img/v31.0808a585.0808a585.svg";